import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Input, notification, Form } from 'antd';
import {Link, useNavigate} from 'react-router-dom';
import axios from 'axios';
import Logo from '../../assets/logo.png'

type FieldType = {
	newPassword?: string;
};

const NewPassword: React.FC = () => {
   const { token } = useParams();

   const navigate = useNavigate()

   const handleSubmit = async (value: any) => {
        const newPassword = value.newPassword
       try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_SERVER}/users/reset-password`, 
                { token, newPassword }, // Datos que se envían en el cuerpo de la solicitud
                {
                    headers: { 'Content-Type': 'application/json' },
                }
            );
            if(response.data.message === 'Password updated successfully'){
                alert('Contraseña cambiada con éxito')
                navigate('/')
            }
        } catch (err: any) {
            alert('Error General')
            navigate('/')
            console.error(err);
            return 401;
        }
    
   };

   return (
    <div className={`flex w-screen h-screen flex-col justify-center gap-1 items-center homePage`}>
        <div className='border-2 border-red-300 p-10 rounded-xl bg-[rgba(255,203,219,0.5)]'>
            <div className='flex justify-center'>
                <img className='h-32' src={Logo}/>
            </div>
            <div>
                <Form
                    name="login"
                    layout='vertical'
                    onFinish={handleSubmit}
                    autoComplete="off"
                >
                    <Form.Item<FieldType>
                        label="Nueva Contraseña"
                        name="newPassword"
                        rules={[{ required: true, message: 'Por favor escribe una contraseña' }]}
                    >
                        <Input.Password />
                    </Form.Item>
                    <Form.Item className='mt-2'>
                        <Button type="primary" htmlType="submit">
                            Restablecer
                        </Button>
                    </Form.Item>
                    <Form.Item className='mt-2'>
                        <Button type="dashed" htmlType="button" onClick={() => navigate('/')}>
                            Cancelar
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    </div>
   );
}

export default NewPassword
